import { useContext } from 'react';
import {
  HeroSection,
  HeroInner,
  WelcomeText,
  Subtitle,
  TwoColumnSection,
  RightHeavySection,
  BalancedSection
} from './Home.styles';
import CurrentCourses from '../CurrentCourses/CurrentCourses';
import Schedule from '../Schedule/Schedule';
import Deadlines from '../Deadlines/Deadlines';
import AcademicSummary from '../AcademicSummary/AcademicSummary';
import MajorRequirements from '../MajorRequirements/MajorRequirements';
import Activities from '../Activities/Activities';
import Resources from '../Resources/Resources';
import StatsGrid from '../StatsGrid/StatsGrid';
import useIsMobile from '../../hooks/useIsMobile';
import { UserContext } from '../../context/UserContextBase';
import { toTitleCaseSingle } from '../../utils';

const Home = () => {
  const isMobile = useIsMobile();
  const { sessionData } = useContext(UserContext);
  return (
    <>
      <HeroSection>
        <HeroInner>
          <WelcomeText>Welcome back, {toTitleCaseSingle(sessionData?.givenNames || '')}</WelcomeText>
          <Subtitle>
            Ready to make this semester your best yet? Here's what's happening<br />
            in your academic journey.
          </Subtitle>
        </HeroInner>
      </HeroSection>
      <StatsGrid />
      {isMobile ? (
        <>
          <CurrentCourses />
          <Schedule />
          <Deadlines />
          <AcademicSummary />
          <MajorRequirements />
          <Activities />
          <Resources />
        </>
      ) : (
        <>
          <CurrentCourses />
          <TwoColumnSection>
            <Schedule />
            <Deadlines />
          </TwoColumnSection>
          <RightHeavySection>
            <AcademicSummary />
            <MajorRequirements />
          </RightHeavySection>
          <BalancedSection>
            <Activities />
            <Resources />
          </BalancedSection>
        </>
      )}
    </>
  );
};

export default Home;
